import dayjs from "dayjs";

export const clock = (dateObj) => {
  let date = new Date();
  if (dateObj !== null && dateObj !== undefined) {
    date = new Date(dateObj);
  }
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  const time = hours + ":" + minutes + " " + ampm;
  return time;
};

export const timeStamp = (dateObj) => {
  let date = new Date();
  if (dateObj !== null && dateObj !== undefined) {
    date = new Date(dateObj);
  }
  return date.toISOString().split("T")[0] + " " + date.toTimeString().split(" ")[0];
};

export const timeValidator = (sTime, eTime, cTime) => {
  // POS-05: compare instants, not "DD-MM-YYYY" strings. The string form sorts by day-of-month first,
  // so any window that crossed a month or year boundary gave the wrong answer.
  const start = sTime ? dayjs(sTime) : dayjs("2000-01-01");
  const end = eTime ? dayjs(eTime) : dayjs("2050-01-01");
  const cur = cTime ? dayjs(cTime) : dayjs();
  return (cur.isAfter(start) || cur.isSame(start)) && (cur.isBefore(end) || cur.isSame(end));
};

export const dateValidator = (sDate, eDate, cDate) => {
  // Read the clock once: with no end date, "now" was read twice and a 1 ms tick between the reads
  // made now > end, so a rule with no end date was skipped at random on a busy PC.
  const now = dayjs();
  const startDate = sDate ? dayjs(sDate) : dayjs("2000-01-01");
  // POS-03: an end date with no time part ("2026-11-30" or "2026-11-30 00:00:00") means the whole
  // of that day. Read literally it ended at 00:00, so the rule stopped working on its last day.
  let endDate = eDate ? dayjs(eDate) : now;
  if (eDate && endDate.hour() === 0 && endDate.minute() === 0 && endDate.second() === 0 && endDate.millisecond() === 0) {
    endDate = endDate.endOf("day");
  }
  const currentDate = cDate ? dayjs(cDate) : now;
  return (currentDate.isAfter(startDate) || currentDate.isSame(startDate)) && (currentDate.isBefore(endDate) || currentDate.isSame(endDate));
};

export const currentDay = () => {
  const date = new Date();
  const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  return days[date.getDay()];
};

const DAYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

// "YYYY-MM-DD HH:mm:ss" (or just "HH:mm[:ss]") -> seconds since midnight; null when missing or unreadable.
const secondsOfDay = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const text = String(value);
  const timePart = text.length > 10 ? text.substring(11) : text;
  const match = /^(\d{1,2}):(\d{2})(?::(\d{2}))?/.exec(timePart);
  if (!match) return null;
  return parseInt(match[1], 10) * 3600 + parseInt(match[2], 10) * 60 + (match[3] ? parseInt(match[3], 10) : 0);
};

/**
 * Whether a time-specific pricing rule is open right now (POS-04).
 * - Uses only the time of day from starttime/endtime, in the till's local time. The old code glued that
 *   time onto the UTC date from timeStamp(), so in IST every time-specific rule failed from 00:00 to 05:30.
 * - A window whose end is before its start (e.g. 22:00-02:00) runs past midnight. The part after
 *   midnight belongs to the day it started, so it uses the previous day's weekday flag.
 * - A missing start or end time means start or end of day.
 */
export const isRuleTimeWindowOpen = (pricingRule, now) => {
  if (!pricingRule || pricingRule.timeSpecific !== "Y") return true;
  const date = now ? new Date(now) : new Date();
  const nowSec = date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();
  const today = DAYS[date.getDay()];
  const yesterday = DAYS[(date.getDay() + 6) % 7];
  const startSec = secondsOfDay(pricingRule.starttime) ?? 0;
  const endSec = secondsOfDay(pricingRule.endtime) ?? 86399;

  if (startSec <= endSec) {
    return nowSec >= startSec && nowSec <= endSec && pricingRule[today] === "Y";
  }
  if (nowSec >= startSec) return pricingRule[today] === "Y";
  if (nowSec <= endSec) return pricingRule[yesterday] === "Y";
  return false;
};
